(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_slider-saection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const heroSwiper = new Swiper('.hero-swiper', {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination-hero',
      clickable: true,
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["move-easy-clinical"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function initCustomSliders() {
      const sliders = document.querySelectorAll('.me-custom-slider');
      
      sliders.forEach(slider => {
        const track = slider.querySelector('.me-slider-track');
        const nextBtn = slider.querySelector('.me-slider-next');
        const prevBtn = slider.querySelector('.me-slider-prev');
        
        // Remove existing clones if re-initializing (e.g. in Theme Customizer)
        const existingClones = track.querySelectorAll('.me-slide-clone');
        existingClones.forEach(clone => clone.remove());
        
        const originalSlides = track.querySelectorAll('.me-slide');
        const slideCount = originalSlides.length;
        
        if (!track || slideCount <= 1) return; 

        // Clone the first and last slides for infinite loop effect
        const firstClone = originalSlides[0].cloneNode(true);
        const lastClone = originalSlides[slideCount - 1].cloneNode(true);
        
        firstClone.classList.add('me-slide-clone');
        lastClone.classList.add('me-slide-clone');
        
        track.appendChild(firstClone);
        track.insertBefore(lastClone, originalSlides[0]);

        let currentIndex = 1; // Start at 1 because index 0 is the cloned last slide
        let isTransitioning = false;
        let autoplayTimer;

        // Set initial position (jump to slide 1 instantly)
        track.style.transition = 'none';
        track.style.transform = `translateX(-100%)`;
        track.offsetHeight; // Force reflow

        function goToSlide(index) {
          if (isTransitioning) return;
          isTransitioning = true;
          
          currentIndex = index;
          track.style.transition = 'transform 0.5s ease-in-out';
          track.style.transform = `translateX(-${currentIndex * 100}%)`;
        }

        // Listener to snap back silently when reaching a clone
        track.addEventListener('transitionend', () => {
          isTransitioning = false;
          
          if (currentIndex === slideCount + 1) { // Hit the cloned first slide
            track.style.transition = 'none';
            currentIndex = 1;
            track.style.transform = `translateX(-${currentIndex * 100}%)`;
            track.offsetHeight; 
          }
          
          if (currentIndex === 0) { // Hit the cloned last slide
            track.style.transition = 'none';
            currentIndex = slideCount;
            track.style.transform = `translateX(-${currentIndex * 100}%)`;
            track.offsetHeight; 
          }
        });

        function startAutoplay() {
          stopAutoplay(); 
          autoplayTimer = setInterval(() => {
            goToSlide(currentIndex + 1);
          }, 10000); 
        }

        function stopAutoplay() {
          clearInterval(autoplayTimer);
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            goToSlide(currentIndex + 1);
            startAutoplay(); 
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            goToSlide(currentIndex - 1);
            startAutoplay(); 
          });
        }

        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);

        startAutoplay();
      });
    }

    initCustomSliders();
    
    document.addEventListener('shopify:section:select', initCustomSliders);
    document.addEventListener('shopify:block:select', initCustomSliders);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["move-easy-nutrients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function initDots() {
      const sections = document.querySelectorAll('.me-nutrients-section');
      
      sections.forEach((section) => {
        const dots = section.querySelectorAll('.me-dot');
        const boxHeading = section.querySelector('.me-box-heading');
        const boxDesc = section.querySelector('.me-box-desc');

        if (!dots.length || !boxHeading) return;

        function updateContent(dot) {
          boxHeading.textContent = dot.dataset.boxHeading || '';
          boxDesc.innerHTML = dot.dataset.boxDesc || ''; 
        }

        dots.forEach((dot) => {
          dot.addEventListener('click', function() {
            dots.forEach(d => d.classList.remove('active'));
            this.classList.add('active');
            updateContent(this);
          });
        });
      });
    }

    initDots();
    document.addEventListener('shopify:section:select', initDots);
    document.addEventListener('shopify:block:select', initDots);
  });

  } catch(e) { console.error(e); }
})();
})();
